import { render } from "./Test.vue?vue&type=template&id=3c9fac7a"
import script from "./Test.vue?vue&type=script&lang=js"
export * from "./Test.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__